import { types } from '../types/types'

export const getLastUpdateDateSiiBot = (values) => ({
    type: types.lastBotUpdateDateSii,
    payload: values
})

export const importLastUpdateDateSiiBot = ( lastUpdateDate ) => {
    return async (dispatch) => {
        try {
            dispatch(getLastUpdateDateSiiBot(lastUpdateDate))
        } catch (error) {
            console.error(error)
        }
    }
}